import styled from 'styled-components';
import {COLOR} from '../constants';

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  max-width: 500px;
  margin: 0 auto;
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${COLOR.SECONDARY_BODY};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  i {
    font-size: 40px;
    color: ${COLOR.PRIMARY};
  }
`;

export const Title = styled.h3`
  color: ${COLOR.TEXT};
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
  line-height: 1.3;
`;

export const Message = styled.p`
  color: #666666;
  font-size: 16px;
  margin: 0 0 32px 0;
  line-height: 1.6;
  max-width: 400px;
`;

export const CTAButton = styled.button`
  background-color: ${COLOR.PRIMARY};
  color: ${COLOR.BODY};
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #2a9dc4;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 183, 229, 0.3);
  }
`;
